export const PageNotFound = () => {
	return <div>404 Not found</div>;
};
